import { module } from 'angular';
import App from '../../../app';

class SCR1402Controller {
	
	constructor ($scope, $state, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		if(!data.width) data.width = 640;
		if(!data.height) data.height = 700;
		
		this.initWindow(data.width, data.height);
		this.initText();
		this.$timeout(() => {
			this.initAppGridOption();
			this.getAppList();
			this.isExpandAll = false;
		});
		
		if(_.isEmpty(this.data) || this.data.limitLvCd === undefined){
			this.data.limitLvCd = 3;
		}
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			titleHeader : bxMsg('manageApp.titleHeader'),
			appCd : bxMsg('manageApp.appCd'),
			appCdNm : bxMsg('manageApp.appCdNm'),
			lvCd : bxMsg('manageApp.lvCd'),
			select : bxMsg('common.select'),
			cancel : bxMsg('common.cancel'),
		};
	}
	
	initAppGridOption(){
		this.gridView = new RealGridJS.TreeView('grid');
		this.dataProvider = new RealGridJS.LocalTreeDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setTreeOptions({lineVisible: false, expandImage: './assets/images/grid/expand.png', collapseImage: './assets/images/grid/collapse.png'});
		this.gridView.setDisplayOptions({vscrollBar: true}); 
		
		this.dataProvider.setFields([
    		{fieldName: "appUnqKey"}, {fieldName: "lvCd"}, {fieldName: "appCd"}, {fieldName: "appCdNm"},
    		{fieldName: "expand", dataType: 'bool'}, {fieldName:"parentAppCd"},
    		{
             	fieldName: "lvCdTxt",
             	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
             		return 'L' + values[fieldNames.indexOf('lvCd')];
         		}
         	}, 
         	{
             	fieldName: "appCdTxt",
             	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
             		const appCd = values[fieldNames.indexOf('appCd')];
             		const appCdNm = values[fieldNames.indexOf('appCdNm')];
             		
             		return appCd + "("+ appCdNm + ")";
         		}
         	}, 
        ]);
		
		this.gridView.setColumns([
			{ name: "lvCdTxt", fieldName: "lvCdTxt", header : { text: this.text.lvCd }, width: 100, styles: { textAlignment: 'center' } },
			{ 
				name: "appCdTxt", fieldName: "appCdTxt", header : { text: this.text.appCd }, width: 200, styles: { textWrap: 'ellipse' },
				dynamicStyles: [				
					{ criteria: 'values["lvCd"] = 2', styles: {paddingLeft: '16px'} },
					{ criteria: 'values["lvCd"] = 3', styles: {paddingLeft: '32px'} },
					{ criteria: 'values["lvCd"] = 4', styles: {paddingLeft: '48px'} },
					{ criteria: 'values["lvCd"] = 5', styles: {paddingLeft: '64px'} }
				]
			}
		]);
		
		this.gridView.onDataCellClicked = (grid, cell) => {
			let row = this.gridView.getValues(cell.itemIndex);
			
			this.selectedRow = row;
			
			if(row.expand) {
				this.gridView.collapse(cell.itemIndex);
			}else{
				this.gridView.expand(cell.itemIndex);
			}
		};
		
		this.gridView.onTreeItemExpanded = (grid, itemIndex) => {
			if(itemIndex === -1) {
				return;
			}
			
			let row = this.gridView.getValues(itemIndex);
			row.expand = true;
			
			grid.setValues(itemIndex, row);
		};
		
		this.gridView.onTreeItemCollapsed = (grid, itemIndex) => {
			if(itemIndex === -1) {
				return;
			}
			
			let row = this.gridView.getValues(itemIndex);
			row.expand = false;
			
			grid.setValues(itemIndex, row);
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getAppList(){
		this.httpService.get('/apps').then(data => {
			this.appcdOutList = data.appcdOutList;
			
			let treeData = this.gridService.convertTreeData(data.appcdOutList, "parentAppCd", "appCd");
			
			this.dataProvider.setJsonRows(treeData, 'rows', '', 'icon');
			
			data.appcdOutList.map((v, idx) => {
				if(v.lvCd == '1') {
					this.gridView.expand(idx);
				}
			});
		});
	}
	
	closeModal(isOk){
		if(isOk){
			if(!this.selectedRow){
				this.$uibModalInstance.dismiss();
			} else {
				let select = this.selectedRow;
				
				if(select.lvCd < this.data.limitLvCd){
					this.popupService.simpleAlert(this.$scope,`코드는 Lv${this.data.limitLvCd}이상부터 선택이 가능합니다.`);
					return;
				} else {
					const codes = [];
					
					while(select && select.parentAppCd){
						codes.push(select);
						
						let idx = this.gridView.searchItem({fields : ['appCd'], values : [select.parentAppCd]})
						select = this.gridView.getValues(idx);
					}
					
					codes.push(select);
					codes.reverse()
					this.$uibModalInstance.close(codes);
				}
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	expandAll(){
		if(this.isExpandAll){
			this.appcdOutList.map((v) => {
				v.expand = false;
			});
			let treeData = this.gridService.convertTreeData(this.appcdOutList, "parentAppCd", "appCd");
			
			this.dataProvider.setJsonRows(treeData, 'rows', '', 'icon');
			this.gridView.collapseAll();
		} else {
			this.appcdOutList.map((v) => {
				v.expand = true;
			});
			let treeData = this.gridService.convertTreeData(this.appcdOutList, "parentAppCd", "appCd");
			
			this.dataProvider.setJsonRows(treeData, 'rows', '', 'icon');
			this.gridView.expandAll();
		}
		
		this.isExpandAll = !this.isExpandAll;
	}
}

module(App.name).controller('SCR1402Controller', SCR1402Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1402/SCR1402.controller.js